// extracted by mini-css-extract-plugin
module.exports = {"PersonaSection":"PersonaSection_PersonaSection__iUk_J","Wrapper":"PersonaSection_Wrapper__LoRGb"};